import type { KeyboardEvent } from 'react'
import { Trash } from 'lucide-react';
import Button from '@/shared/components/ui/Button';

interface CardDetailAddresProps {
    isPrimary?: boolean;
    location: string;
    user: string;
    phone: string;
    address: string;
    postalCode: string;
    onEdit?: () => void;
    onDelete?: () => void;
    deleteDisabled?: boolean;
    /** Choosing mode (Pilih Alamat): the card is a radio and the highlight follows the choice */
    onSelect?: () => void;
    isSelected?: boolean;
}

const CardDetailAddress = ({ isPrimary = false, location, phone, address, postalCode, user, onEdit, onDelete, deleteDisabled = false, onSelect, isSelected = false }: CardDetailAddresProps) => {
    const isHighlighted = onSelect ? isSelected : isPrimary;
    const selectProps = onSelect && {
        role: 'radio',
        'aria-checked': isSelected,
        'aria-label': `${location || user}${isPrimary ? ' (utama)' : ''}`,
        tabIndex: 0,
        onClick: onSelect,
        onKeyDown: (e: KeyboardEvent) => {
            if (e.target !== e.currentTarget || (e.key !== 'Enter' && e.key !== ' ')) return;
            e.preventDefault();
            onSelect();
        },
    };

    return (
        <div
            className={`shadowCard p-3 flex flex-col gap-3 ${isHighlighted ? 'bg-[#007AFF]/4 border border-text-blue-10' : 'shadowCard'} ${onSelect ? 'cursor-pointer' : ''}`}
            {...selectProps}
        >
            <div className="inline-flex gap-3 justify-between items-center ">
                <p className='title2medium text-black'>{location}</p>
                {isPrimary && (
                    <p className='reg12 px-3 py-1 rounded-[4px] bg-text-blue-10 text-text-blue-100 text-center capitalize'>utama</p>
                )}

            </div>
            <div className="w-full title3medium gap-1 text-black flex flex-col">
                <p className='title2medium'>{user}</p>
                <p>{phone}</p>
                <p className='text-text-grey'>{address}</p>
                <p>{postalCode}</p>
            </div>
            <div className="w-full inline-flex gap-3 items-center">
                <Button
                    type='button'
                    customButton='btn-fill-white flex-1'
                    onClick={(e) => {
                        e.stopPropagation();
                        onEdit?.();
                    }}
                >
                    <span className='title3medium'>Ubah Alamat</span>
                </Button>
                <Button
                    type='button'
                    onClick={(e) => {
                        e.stopPropagation();
                        onDelete?.();
                    }}
                    disabled={deleteDisabled}
                    aria-label={`Hapus alamat ${location || user}`}
                >
                    <Trash className='size-5' color='red' />
                </Button>

            </div>
        </div>
    )
}

export default CardDetailAddress
